import { create } from "zustand";

type ChartDialogOptions = {
  refTime: string | undefined;
};

type ChartDialogState = {
  isOpen: boolean;
  closeDialog: () => void;
  openDialog: (options?: ChartDialogOptions) => void;
  refTime: string | undefined;
};

const useChartDialogStore = create<ChartDialogState>(set => ({
  isOpen: false,
  refTime: undefined,
  closeDialog: () => set({ isOpen: false }),
  openDialog: (options = { refTime: undefined }) => set({ ...options, isOpen: true }),
}));

export default useChartDialogStore;